export default __webpack_public_path__ + "static/media/lateral-left.d72cdbec.png";